export default __webpack_public_path__ + "static/media/card6.ce927a50.png";